import { getTargetFeatureHelper } from "./getTargetFeatureHelper";

export default getTargetFeatureHelper;
